import { CloseCommand } from "slotworks/commands/comms/close-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import State from "slotworks/state-machine/states/state";

export default class GameOver extends State {
    public onEnter() {
        Services.transaction.setBalance(GameState.getCurrentGame().balance);

        Components.footer.showNoWin();

        CloseCommand().then(() => this.complete());
    }
}
